import styled from "styled-components";

export const MainInfoWrapper = styled.div`
  margin-top: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  border-radius: 20px;
  background: #f0f0f0;

  padding: 30px 20px;
  overflow-y: auto;

  p {
    margin: 0;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-block-start: 0;
    margin-block-end: 0;
  }
`;

export const MainInfoHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  background: #6436e7;
  margin-bottom: 20px;
`;

export const MainInfoHeaderItem = styled.div<{ flex: number }>`
  flex: ${({ flex }) => flex};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 0px 6px;
  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const MainInfoContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

export const MainInfoContentItem = styled.div<{ flex: number }>`
  flex: ${({ flex }) => flex};
  display: flex;
  justify-content: center;
  align-items: center;

  > .label {
    color: #444;
    text-align: center;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const MainInfoContentItemInput = styled.input`
  width: calc(100% - 16px);
  padding: 5.396px 8.093px;
  border: none;
  outline: none;
  border-radius: 2.698px;
  border: 0.674px solid var(--Black-200, #b7b7b7);
  background: #fff;
`;

export const MainInfoColorInput = styled.input`
  width: 22px;
  height: 22px;
  border: 1px solid #b7b7b7;
  border-radius: 22px;
  cursor: pointer;
  padding: 0;
  background: transparent;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch {
    border: none;
    border-radius: 4px;
  }
`;

export const ColorInput = styled.input`
  width: 32px;
  height: 32px;
  border: 1px solid #b7b7b7;
  border-radius: 40px;
  cursor: pointer;
  padding: 0;
  background: transparent;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch {
    border: none;
    border-radius: 4px;
  }
`;

export const MainInfoSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

export const MainInfoSectionItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  > span {
    color: #444;
    font-family: Pretendard;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 60px; /* 200% */
  }

  > .padding-label {
    width: 100px;
    color: #444;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .label {
    width: 80px;
    color: #444;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .font-size {
    color: #1a191a;
    text-align: center;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
